// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"720":"6bffc308","859":"6bffc308"}[chunkId] + ".chunk.css");